export default () => ({
  lastTransactions: [],
});
